import { FadeUp, Overline } from "@/components/Reveal";

const HUB = { x: 620, y: 320 };
const CITIES = [
  { name: "LONDON", x: 170, y: 150 },
  { name: "AMSTERDAM", x: 250, y: 80 },
  { name: "FRANKFURT", x: 330, y: 115 },
  { name: "PARIS", x: 235, y: 205 },
  { name: "NEW YORK", x: 90, y: 275 },
  { name: "KUWAIT", x: 720, y: 280 },
  { name: "RIYADH", x: 700, y: 370 },
  { name: "DOHA", x: 762, y: 395 },
  { name: "JOHANNESBURG", x: 560, y: 520 },
  { name: "SINGAPORE", x: 975, y: 425 },
  { name: "HONG KONG", x: 1060, y: 320 },
  { name: "SEOUL", x: 1120, y: 215 },
];

const pathFor = (c) => {
  const cx = (HUB.x + c.x) / 2;
  const cy = Math.min(HUB.y, c.y) - 70;
  return `M${HUB.x},${HUB.y} Q${cx},${cy} ${c.x},${c.y}`;
};

export const GlobalMap = () => (
  <section id="network" className="relative py-16 lg:py-24 bg-white overflow-hidden" data-testid="network-section">
    <img
      src="https://images.unsplash.com/photo-1579525612525-053cd3e8cbd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxkdWJhaSUyMHNreWxpbmUlMjBkYXklMjBjbGVhcnxlbnwwfHx8fDE3OTEwMzg2MDd8MA&ixlib=rb-4.1.0&q=85"
      alt="Dubai skyline"
      className="absolute inset-x-0 bottom-0 w-full h-1/2 object-cover opacity-[0.07]"
      loading="lazy"
    />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp>
        <Overline>Global Supply Network</Overline>
        <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-midnight">
          UAE based. Globally connected.
        </h2>
        <p className="text-midnight/55 text-lg mt-6 max-w-2xl leading-relaxed">
          Connecting international technology supply with commercial demand across the GCC, Europe, Africa, Asia-Pacific and other global markets.
        </p>
      </FadeUp>

      <FadeUp delay={0.15} className="mt-14">
        <div className="bg-white hairline shadow-soft p-2 sm:p-8" data-testid="network-map">
          <svg viewBox="0 0 1200 600" className="w-full h-auto" role="img" aria-label="Royal Deals FZ-LLC supply network centred on the UAE">
            <defs>
              <radialGradient id="hubGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#C5A059" stopOpacity="0.35" />
                <stop offset="100%" stopColor="#C5A059" stopOpacity="0" />
              </radialGradient>
            </defs>

            {CITIES.map((c, i) => (
              <g key={c.name}>
                <path
                  d={pathFor(c)}
                  fill="none"
                  stroke="#0A192F"
                  strokeOpacity="0.18"
                  strokeWidth="1"
                  strokeDasharray="3 7"
                  className="animate-dash-flow"
                  style={{ animationDelay: `${i * 0.15}s` }}
                />
                <circle r="2.6" fill="#C5A059" opacity="0.9">
                  <animateMotion dur={`${3.5 + (i % 4)}s`} repeatCount="indefinite" path={pathFor(c)} begin={`${i * 0.4}s`} />
                </circle>
                <circle cx={c.x} cy={c.y} r="3.5" fill="#0A192F" opacity="0.85" />
                <circle cx={c.x} cy={c.y} r="8" fill="none" stroke="#0A192F" strokeOpacity="0.15" />
                <text x={c.x} y={c.y - 14} textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="Outfit, sans-serif" fontWeight="600" letterSpacing="2">
                  {c.name}
                </text>
              </g>
            ))}

            <circle cx={HUB.x} cy={HUB.y} r="48" fill="url(#hubGlow)" />
            <circle cx={HUB.x} cy={HUB.y} r="6" fill="#C5A059" />
            <circle cx={HUB.x} cy={HUB.y} r="14" fill="none" stroke="#C5A059" strokeOpacity="0.6" className="animate-pulse-dot" />
            <text x={HUB.x} y={HUB.y - 26} textAnchor="middle" fill="#0A192F" fontSize="14" fontFamily="Outfit, sans-serif" fontWeight="700" letterSpacing="3">
              UAE — RAKEZ
            </text>
          </svg>
        </div>
        <p className="mt-4 text-xs text-midnight/40">
          Trading reach — not physical branches. Delivery structures are coordinated per transaction.
        </p>
      </FadeUp>
    </div>
  </section>
);
